import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum BloodTypeEnum {
    A0_POSITIVE = 'A0P',
    A0_NEGATIVE = 'A0N',
    AA_POSITIVE = 'AAP',
    AA_NEGATIVE = 'AAN',
    B0_POSITIVE = 'B0P',
    B0_NEGATIVE = 'B0N',
    BB_POSITIVE = 'BBP',
    BB_NEGATIVE = 'BBN',
    AB_POSITIVE = 'ABP',
    AB_NEGATIVE = 'ABN',
    ZERO_POSITIVE = 'ZP',
    ZERO_NEGATIVE = 'ZN',
}

export const bloodTypeEnumOptions = enumToOptions(BloodTypeEnum, 'enum.bloodType.');
